import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { openSidebar, closeSidebar, showPortalPage, toggleSidebar } from 'js/components/main/MyAccountSidebar/store/actions';

export const useSidebarPublicAPI = () => {
    const dispatch = useDispatch();

    return useMemo(() => ({
        /**
         * Opens sidebar.
         * @memberOf Playtech.API.sidebar
         * @function
         * @example
         * Playtech.API.sidebar.open();
         */
        open: () => dispatch(openSidebar()),
        /**
         * Toggles sidebar.
         * @memberOf Playtech.API.sidebar
         * @function
         * @example
         * Playtech.API.sidebar.toggle();
         */
        toggle: () => dispatch(toggleSidebar()),
        /**
         * Closes sidebar
         * @memberOf Playtech.API.sidebar
         * @function
         * @example
         * Playtech.API.sidebar.close();
         */
        close: () => dispatch(closeSidebar()),
        /**
         * Opens sidebar with a specific portal page within
         * @memberOf Playtech.API.sidebar
         * @function
         * @param {string} pageURL
         * @param {boolean} isBackArrowHidden
         * @example
         * Playtech.API.sidebar.openPage('/test-page', false);
         */
        openPage: (pageURL, isBackArrowHidden = true) => {
             dispatch(openSidebar());
             dispatch(showPortalPage({ pageURL, isBackArrowHidden }));
        },
        /**
         * Navigates to a portal page with an opened sidebar
         * @memberOf Playtech.API.sidebar
         * @function
         * @param {string} pageURL
         * @example
         * Playtech.API.sidebar.navigateToPage('/test-page');
         */
        navigateToPage: (pageURL) => {
            dispatch(showPortalPage({ pageURL }));
        }
    }), [dispatch]);
};
